import HttpClient from "../helpers/HttpClient"
import Template, {TemplateDto} from "./Template"
import {HttpError, isError} from "../helpers/Error"
import {SMSTemplatePayload} from "./TemplatePayload"

class TemplateService {
    httpClient: HttpClient<Template, TemplateDto> = new HttpClient<Template, TemplateDto>(Template)

    async createTemplate(payload: SMSTemplatePayload, templateKey: string): Promise<Template | HttpError> {
        const res = await this.httpClient.post(`/templates/${templateKey}`, payload)
        if (isError(res)) {
            return res as HttpError
        }
        return res as Template
    }

    async findAllTemplates(templateType: string, templateKey: string): Promise<Template[] | HttpError> {
        const res = await this.httpClient.get(`/templates/${templateType}?templateKey=${templateKey}`)
        if (isError(res)) {
            return res as HttpError
        }
        return res as Template[]
    }

    async findByTemplateKey(templateKey: string): Promise<Template | HttpError> {
        const res = await this.httpClient.get(`/templates/${templateKey}/template`)
        if (isError(res)) {
            return res as HttpError
        }
        return res as Template
    }

    async updateByTemplateKey(payload: SMSTemplatePayload, templateKey: string): Promise<Template | HttpError> {
        const res = await this.httpClient.patch(`/templates/${templateKey}`, payload)
        if (isError(res)) {
            return res as HttpError
        }
        return res as Template
    }

    async deleteByTemplateId(templateId: string): Promise<Template | HttpError> {
        const res = await this.httpClient.delete(`/templates/${templateId}`)
        if (isError(res)) {
            return res as HttpError
        }
        return res as Template
    }
}

const instance = new TemplateService()
export default instance


// WEBPACK FOOTER //
// ./src/state/template/TemplateService.ts